var StandoffSpacerData = require('./standoffSpacerData.js');
var lib_core = require("lib-core");
var PthComponentAttribute = require('./pthComponentAttribute.js');

var MaleFemaleStandoffSpacerData = function(position, angle, init) {
    var self = this;
    StandoffSpacerData.apply(this, arguments);

    this.postLength = this.value("postLength", true);
    this.postThreadType = this.value("postThreadType", true);
    this.postThreadSize = this.value("postThreadSize", true);
    this.postThreadDesignation = this.value("postThreadDesignation", true);

    this.innerThreadDepth = this.value("innerThreadDepth", true);
    this.innerThreadType = this.value("innerThreadType", true);
    this.innerThreadSize = this.value("innerThreadSize", true);
    this.innerThreadDesignation = this.value("innerThreadDesignation", true);

    this.nonTransformedSegmentedGeometry.addTrigger(this.postLength);
    this.nonTransformedSegmentedGeometry.addTrigger(this.postThreadType);
    this.nonTransformedSegmentedGeometry.addTrigger(this.postThreadSize);
    this.nonTransformedSegmentedGeometry.addTrigger(this.postThreadDesignation);
    
    this.nonTransformedSegmentedGeometry.addTrigger(this.innerThreadDepth);
    this.nonTransformedSegmentedGeometry.addTrigger(this.innerThreadType);
    this.nonTransformedSegmentedGeometry.addTrigger(this.innerThreadSize);
    this.nonTransformedSegmentedGeometry.addTrigger(this.innerThreadDesignation);

    this.gender(PthComponentAttribute.type.ELECTRO_MECHANICAL.types.STANDOFF_SPACER.genders.MALE_FEMALE);
    this.innerThreadType(PthComponentAttribute.threadTypes.ISO_METRIC.name);
    this.postThreadType(PthComponentAttribute.threadTypes.ISO_METRIC.name);
};

lib_core.inherit(MaleFemaleStandoffSpacerData, StandoffSpacerData);
lib_core.JsonParser.registerClass(MaleFemaleStandoffSpacerData, "MaleFemaleStandoffSpacerData");

module.exports = MaleFemaleStandoffSpacerData;